import React, { useMemo } from 'react'
import _ from 'lodash'

const MatchScores = (props) => {

  const { results, results_matchDay, forGrid } = props

  const _results = results ? results : results_matchDay

  const { scores, score, scoreDisplays, winner } = _results ?? {}
  const { pointDifference } = scoreDisplays ?? {}
  const { points, team } = pointDifference ?? {}
  const { name } = winner ?? {}

  const winnerHasMostPoints = name === team

  const { scrz } = useMemo(() => {
    if (!scores && !score) return
    if (!_.isEmpty(scores)) {
      let scrd = _.map(scores, (score, setNumber) => (
        <div className='abs slo'><span className='abw'>{score.away}</span><span>-</span><span className='abl'>{score.home}</span></div>
      ))
      return { scrz: scrd }
    } else if (score) {
      return <div className='abs'><span className='abw'>{score.away}</span><span>-</span><span className='abl'>{score.home}</span></div>
    }
  }, [scores, score])

  if (forGrid) {
    return <div className='match-rez'>
      <div className={'mrl'}>
        {scrz}
      </div>
    </div>
  } else {
    return <div className='match-rez'>
      <div title='Point Difference' className={'mrl-c'}>{`🔀 ${points}`}</div>
      <div className={'mrl'}>
        {scrz}
      </div>
      <div className={'mrl-s'} >{'🛡️'}</div>
    </div>
  }

  return scrz

}

export default MatchScores